import Icons from '../../components/Menu/Icons';
import { isLuciaColetaAtivada } from '../../utils/luciaColeta';

const isFeatureEnabled = (value) => value === true || value === 1;

const integracaoSection = {
  title: 'Integração',
  pathSegment: 'integracao',
  subItems: [
    { title: 'WebHooks', slug: 'webhooks' },
    {
      title: 'Documentação',
      slug: 'documentacao',
      href: 'https://doc-api.fichacertadigital.com.br/',
      external: true,
    },
  ],
};

const menuItemsUserMaster = [
  {
    title: "Cadastro",
    subItems: [
      { title: 'Dados do cliente', slug: 'dados-cliente' },
      { title: 'Usuários', slug: 'usuarios' },
    ]
  },
  {
    title: "Financeiro",
    subItems: [
      // { title: 'Preços', slug: 'precos' },
      { title: 'Relatório de consumo', slug: 'relatorio' },
      { title: 'Segunda via de boleto', slug: 'segunda-via-boleto' }
    ]
  },
  {
    title: 'Operacional',
    subItems: [
      {title: 'Locações', slug: 'solicitacao'},
      { title: 'LucIA - Imobiliária', slug: 'chats-solicita' },
      { title: 'LucIA - Pretendentes', slug: 'chats-coleta' },
    ]
  },
  {
    title: 'BI (v.beta)',
    pathSegment: 'bi',
    subItems: [
      { title: 'Extração de Dados', slug: 'extracao-dados' }
    ]
  },
  {
    title: 'Suporte',
    subItems: [
      {title: `(21)98734-6472`, slug: 'wpp', icon: Icons.WPP()},
      // {title: `(21)2222-4998`, slug: 'tel', icon: Icons.Telefone()},
      {title: `fcanalise@fichacerta.com.br`, slug: 'email', icon: Icons.Email()},
    ]
  }
]

const menuItemsSemParecer = [
  {
    title: "Cadastro",
    subItems: [
      { title: 'Dados do cliente', slug: 'dados-cliente' },
      { title: 'Usuários', slug: 'usuarios' }
    ]
  },
  {
    title: "Financeiro",
    subItems: [
      { title: 'Relatório de consumo', slug: 'relatorio' },
      { title: 'Segunda via de boleto', slug: '' }
    ]
  },
  {
    title: 'Operacional',
    subItems: [
      {title: 'Locações', slug: 'solicitacao'},
      { title: 'LucIA - Imobiliária', slug: 'chats-solicita' },
      { title: 'LucIA - Pretendentes', slug: 'chats-coleta' },
    ]
  },
  {
    title: 'Suporte',
    subItems: [
      {title: `(21)98734-6472`, slug: 'wpp', icon: Icons.WPP()},
      // {title: `(21)2222-4998`, slug: 'tel', icon: Icons.Telefone()},
      {title: `fcanalise@fichacerta.com.br`, slug: 'email', icon: Icons.Email()},
    ]
  }
]

const omitColetaMenu = (sections) => sections.map((section) => ({
  ...section,
  subItems: (section.subItems || []).filter((item) => item.slug !== 'chats-coleta'),
}));

const withIntegracaoMenu = (items, usuario) => {
  if (!isFeatureEnabled(usuario?.integracao_webhooks)) {
    return items;
  }

  const next = items.map((section) => ({ ...section, subItems: [...section.subItems] }));
  const suporteIdx = next.findIndex((section) => section.title === 'Suporte');

  if (suporteIdx >= 0) {
    next.splice(suporteIdx, 0, { ...integracaoSection, subItems: [...integracaoSection.subItems] });
  } else {
    next.push({ ...integracaoSection, subItems: [...integracaoSection.subItems] });
  }

  return next;
};

const buildMenuForUser = (usuario) => {
  let menu;

  if (!usuario?.master) {
    menu = menuItemsSemParecer;
  } else {
    menu = menuItemsUserMaster.map((section, index) => {
      if (index !== 0) {
        return section;
      }

      const subItems = [...section.subItems];

      if (isFeatureEnabled(usuario.recomendacao_ativada)) {
        subItems.push({ title: 'Regras de Aprovação', slug: 'customizar-pareceres' });
      }

      return { ...section, subItems };
    });
  }

  menu = withIntegracaoMenu(menu, usuario);

  return isLuciaColetaAtivada(usuario?.lucia_coleta_ativada) ? menu : omitColetaMenu(menu);
};

export { menuItemsSemParecer, menuItemsUserMaster, buildMenuForUser };
